import { Component, inject, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { AllStatus } from '../../../../core/services/status/all-status';
import { Downtime } from '../../../../core/services/times/downtime';

@Component({
  selector: 'app-training-mode',
  imports: [TranslatePipe, MatCheckboxModule],
  templateUrl: './training-mode.html',
  styleUrl: './training-mode.scss'
})

export class TrainingMode implements OnInit {

  allStatus = inject(AllStatus);
  downtime = inject(Downtime);

  ngOnInit(): void {
    //this.allStatus.clearTrainingMode();
    this.allStatus.setTrainingMode(1);
  }

  fnTrainingMode(checked: boolean){
    this.downtime.refreshTimer();
    if(checked){
      this.allStatus.setTrainingMode(1);
    }else{
      this.allStatus.clearTrainingMode();
    }
  }

}
